import type { EventDetail } from "@cdt/shared";
import { useQuery } from "@tanstack/react-query";

import { ApiError } from "@/lib/api";
import { fetchEvent } from "@/lib/eventsApi";

export function eventDetailQueryKey(id: string) {
  return ["events", "detail", id] as const;
}

export function useEventQuery(id: string | undefined) {
  return useQuery<EventDetail, ApiError>({
    queryKey: eventDetailQueryKey(id ?? ""),
    queryFn: () => {
      if (!id) {
        return Promise.reject(new ApiError(400, null, "Missing event id"));
      }
      return fetchEvent(id);
    },
    enabled: Boolean(id),
    retry: (failureCount, error) => {
      if (error instanceof ApiError && error.status === 404) return false;
      return failureCount < 1;
    },
  });
}
